var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input input--checkbox", class: _vm.inputClass },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentValue,
            expression: "currentValue",
          },
        ],
        attrs: {
          type: "checkbox",
          id: "checkbox" + _vm._uid,
          disabled: _vm.disabled,
        },
        domProps: {
          checked: Array.isArray(_vm.currentValue)
            ? _vm._i(_vm.currentValue, null) > -1
            : _vm.currentValue,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.currentValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.currentValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.currentValue = $$c
            }
          },
        },
      }),
      _c("div", { staticClass: "input--checkbox__indicator" }),
      _c("label", { attrs: { for: "checkbox" + _vm._uid } }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }